@if (state$ | async; as state) {
  <button class="heading" (click)="toggleGroup($event)">
    {{ facet.name }}
    <app-custom-icons
      [class]="!(selected && isVisible) ? 'icon-arrow ' : 'icon-arrow rotate'"
      [type]="(isMobile() | async) ? iconTypes.ADD : iconTypes.ARROW_DOWN_ICON">
    </app-custom-icons>
  </button>
  @if (selected && isVisible) {
    <div class="facets-elements">
      @for (value of facet.values | slice: 0:state.topVisible; track value) {
        <a
          #facetValue
          routerLink="./"
          [queryParams]="getLinkParams(value)"
          class="value"
          [class.selected]="value.selected"
          [cxFocus]="value.name"
          (keydown.space)="openLink($event)"
          >
          <span>
            <input
              type="checkbox"
              [checked]="value.selected"
              />
            <span class="label">{{ value.name }}</span>
            <span class="count">{{ value.count }}</span>
          </span>
        </a>
      }
      <div class="more">
        @for (
          value of facet.values | slice: state.topVisible:state.maxVisible
          ; track
          value) {
          <a
            #facetValue
            routerLink="./"
            [queryParams]="getLinkParams(value)"
            class="value"
            [class.selected]="value.selected"
            [cxFocus]="value.name"
            (keydown.space)="openLink($event)"
            >
            <span>
              <input
                type="checkbox"
                [checked]="value.selected"
                />
              <span class="label">{{ value.name }}</span>
              <span class="count">{{ value.count }}</span>
            </span>
          </a>
        }
        @if (state.maxVisible > state.topVisible) {
          <button
            (click)="decreaseVisibleValues()"
            class="cx-action-link"
            cxFocus="moreorless"
            >
            {{ 'productList.showLess' | cxTranslate }}
          </button>
        }
        @if (state.maxVisible > 0 && state.maxVisible < facet.values.length) {
          <button
            (click)="increaseVisibleValues()"
            class="cx-action-link"
            cxFocus="moreorless"
            >
            {{ 'productList.showMore' | cxTranslate }}
          </button>
        }
      </div>
    </div>
  }
}
